<div
  *ngIf="loading"
  class="absolute inset-0 grid bg-neutral-950 bg-opacity-80 h-full z-50"
>
  <div class="m-auto flex flex-col items-center">
    <p-progressSpinner ariaLabel="loading" class="mb-3" />
    <div class="text-neutral-200 text-sm">
      Chargement des données de l'affaire...
    </div>
  </div>
</div>

<!-- Dialog de confirmation -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  styleClass="p-confirm-dialog-custom"
></p-confirmDialog>

<div
  *ngIf="error"
  class="p-4 mb-4 bg-red-100 border border-red-300 rounded-lg shadow-sm"
>
  <p class="text-red-700 flex items-center">
    <i class="pi pi-exclamation-circle mr-2"></i>
    {{ error }}
  </p>
  <div class="mt-4">
    <button
      pButton
      type="button"
      label="Retour"
      (click)="cancelReschedule()"
      class="p-button-secondary"
    ></button>
  </div>
</div>

<p-card
  styleClass="w-full flex flex-1 relative"
  class="stepper-card"
  *ngIf="intervention && !error"
>
  <div class="flex flex-col w-full h-full overflow-hidden">
    <!-- En-tête avec informations de l'intervention et étapes -->
    <div class="header-steps-container">
      <div class="flex justify-between items-center flex-wrap">
        <!-- Informations de l'intervention -->
        <div class="intervention-header-section">
          <div class="intervention-info-content">
            <h2
              class="intervention-title text-truncate"
              title="{{ intervention.name }}"
            >
              {{ intervention.name }}
            </h2>
            <div class="flex items-center gap-3 mb-1">
              <span class="intervention-ref">
                <i class="pi pi-tag"></i> {{ intervention.id }} ({{
                  intervention.erpSource | uppercase
                }})
              </span>
              <span
                class="intervention-location"
                *ngIf="intervention.affair?.workSiteLocality"
              >
                <i class="pi pi-map-marker"></i>
                {{ intervention.affair.workSitePostalCode }}
                {{ intervention.affair.workSiteLocality }}
              </span>
            </div>
            <div class="flex items-center gap-3">
              <span class="intervention-time">
                <i class="pi pi-calendar"></i>
                {{ formatDisplayDate(intervention.startDate) }}
              </span>
              <span class="intervention-duration">
                <i class="pi pi-clock"></i> {{ getDisplayDuration() }}
              </span>
              <span
                class="intervention-time-type"
                *ngIf="intervention.isTimeSlot"
              >
                <i class="pi pi-sliders-h"></i> Créneau:
                {{ intervention.startTimeSlot }} -
                {{ intervention.endTimeSlot }}
              </span>
            </div>
          </div>
        </div>

        <!-- Étapes -->
        <div class="steps-section">
          <p-steps
            [activeIndex]="activeStep()"
            [model]="steps"
            styleClass="modern-steps"
            [readonly]="true"
          ></p-steps>
        </div>
      </div>
    </div>

    <!-- Contenu de l'étape active -->
    <div class="mt-4 w-full flex-grow flex flex-col min-h-0">
      <div class="step-content w-full h-full flex-grow overflow-auto">
        <!-- Étape 1: Sélection des produits - Utiliser notre nouveau composant -->
        <ng-container *ngIf="activeStep() === 0">
          <app-intervention-reschedule-products
            class="w-full h-full block"
            [affair]="intervention.affair"
            [products]="allProducts"
            [loadingProducts]="loadingProducts"
            [restoredSelectedProductIds]="
              productsDataReady ? getSelectedProductIds() : []
            "
            [restoredProductGroup]="
              productGroups.length ? productGroups[0] : null
            "
            [resetSelection]="productResetFlag"
            [interventionProducts]="intervention.affairProducts"
            (productSelectionChanged)="onProductSelectionChanged($event)"
            (productGroupCreated)="onProductGroupCreated($event)"
          ></app-intervention-reschedule-products>
        </ng-container>

        <!-- Étape 2: Sélection des techniciens - Composant partagé -->
        <ng-container *ngIf="activeStep() === 1">
          <app-affair-schedule-technicians-select
            class="w-full h-full flex"
            [affair]="intervention.affair"
            [users]="users$ | async"
            [loadingUsers]="loadingUsers"
            [resetMap]="resetMapFlag"
            [isActive]="activeStep() === 1"
            [originalTechnicians]="intervention.usersTechnicians"
            [selectedProducts]="selectedProducts"
            [initialDateRange]="
              dateRange().length === 2 ? $any(dateRange()) : null
            "
            [excludeInterventionId]="intervention.id"
            [labelNewItem]="'intervention'"
            [newItemNameOverride]="intervention.affair.mlRef || ''"
            (techniciansSelected)="onTechniciansSelected($event)"
            (dateRangeSelected)="onDateRangeSelected($event)"
            (closestInterventionsChanged)="
              onClosestInterventionsChanged($event)
            "
            (slotPreSelected)="onSlotPreSelected($event)"
          ></app-affair-schedule-technicians-select>
        </ng-container>

        <!-- Étape 3: Sélection du créneau horaire - Utiliser notre nouveau composant spécifique -->
        <ng-container *ngIf="activeStep() === 2">
          <app-intervention-reschedule-time-select
            class="w-full"
            [affair]="intervention.affair"
            [selectedTechnicians]="selectedTechnicians"
            [selectedDateRange]="dateRange()"
            [users]="users$ | async"
            [loadingUsers]="loadingUsers"
            [droppedEventDetails]="droppedDetails"
            [resetCalendar]="calendarReset"
            [closestInterventions]="closestInterventions"
            [selectedProducts]="selectedProducts"
            [productGroups]="productGroups"
            [preSelectedSlot]="preSelectedSlotData"
            [excludeInterventionId]="intervention.id"
            (dropDetails)="onDropDetails($event)"
            (dateRangeChange)="onDateRangeSelected($event)"
            (filtersChanged)="updateFilters($event)"
          ></app-intervention-reschedule-time-select>
        </ng-container>

        <!-- Étape 4: Programmation -->
        <ng-container *ngIf="activeStep() === 3">
          <app-affair-schedule-intervention-schedule
            class="w-full"
            [droppedDetails]="droppedDetails"
            [selectedTechnicians]="selectedTechnicians"
            [scheduleForm]="scheduleForm"
            [dateRange]="dateRange()"
            [usersList]="interventionScheduleUsers"
            (formScheduleChanged)="scheduleData = $event"
          ></app-affair-schedule-intervention-schedule>
        </ng-container>

        <!-- Étape 5: Informations complémentaires -->
        <ng-container *ngIf="activeStep() === 4">
          <!-- Message d'erreur -->
          <div
            *ngIf="interventionError"
            class="p-4 mb-4 bg-red-100 border border-red-300 rounded-lg shadow-sm"
          >
            <p class="text-red-700 flex items-center">
              <i class="pi pi-exclamation-circle mr-2"></i>
              {{ interventionError }}
            </p>
          </div>

          <!-- Composant de création d'intervention -->
          <app-affair-schedule-intervention-create
            class="w-full"
            [affair]="intervention.affair"
            [selectedTechnicians]="selectedTechnicians"
            [dateRange]="dateRange()"
            [droppedDetails]="droppedDetails"
            [scheduleData]="scheduleData"
            [interventionForm]="interventionForm"
          ></app-affair-schedule-intervention-create>
        </ng-container>
      </div>
    </div>

    <!-- Augmenter l'espace après le contenu principal pour éviter le chevauchement avec les boutons -->
    <div class="pb-32"></div>
  </div>
</p-card>

<!-- Boutons de navigation -->
<div class="navigation-buttons">
  <div class="nav-container">
    <div class="flex justify-between w-full">
      <div class="flex gap-2">
        <!-- Bouton d'annulation -->
        <button
          pButton
          type="button"
          icon="pi pi-times"
          label="Annuler"
          class="p-button-outlined p-button-danger"
          (click)="cancelReschedule()"
          [disabled]="submitting"
        ></button>

        <!-- Bouton de réinitialisation -->
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          label="Réinitialiser"
          class="p-button-outlined p-button-secondary"
          (click)="resetForm()"
          [disabled]="loading || submitting"
        ></button>

        <!-- Bouton précédent -->
        <button
          pButton
          type="button"
          [disabled]="activeStep() === 0 || submitting"
          (click)="previousStep()"
          label="Précédent"
          class="p-button-outlined"
        ></button>
      </div>

      <div>
        <!-- Bouton suivant -->
        <ng-container *ngIf="activeStep() < steps.length - 1">
          <button
            pButton
            type="button"
            (click)="nextStep()"
            [disabled]="
              (activeStep() === 0 &&
                (!selectedProducts ||
                  selectedProducts.length === 0 ||
                  loadingProducts)) ||
              (activeStep() === 1 && !isTechniciansSelected) ||
              (activeStep() === 2 && !hasDroppedEvent) ||
              submitting
            "
            label="Suivant"
            class="p-button-primary"
          ></button>
        </ng-container>

        <!-- Bouton de soumission -->
        <ng-container *ngIf="activeStep() === steps.length - 1">
          <button
            pButton
            type="button"
            (click)="submitReschedule()"
            [loading]="submitting"
            label="Replanifier l'intervention"
            class="p-button-success"
          ></button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
